import { useCallback, useEffect, useState } from 'react'

export type ScriptConvention = 'cn' | 'hollywood'

export interface ScriptFormatPrefs {
  convention: ScriptConvention
}

export const DEFAULT_SCRIPT_FORMAT_PREFS: ScriptFormatPrefs = {
  convention: 'cn',
}

const STORAGE_KEY = 'studio.script.formatPrefs.v2'

export function loadScriptFormatPrefs(): ScriptFormatPrefs {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return DEFAULT_SCRIPT_FORMAT_PREFS
    return { ...DEFAULT_SCRIPT_FORMAT_PREFS, ...JSON.parse(raw) }
  } catch {
    return DEFAULT_SCRIPT_FORMAT_PREFS
  }
}

export function saveScriptFormatPrefs(prefs: ScriptFormatPrefs) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs))
}

export function useScriptFormatPrefs() {
  const [prefs, setPrefsState] = useState<ScriptFormatPrefs>(() => loadScriptFormatPrefs())

  const setPrefs = useCallback((patch: Partial<ScriptFormatPrefs>) => {
    setPrefsState((prev) => {
      const next = { ...prev, ...patch }
      saveScriptFormatPrefs(next)
      return next
    })
  }, [])

  useEffect(() => {
    saveScriptFormatPrefs(prefs)
  }, [prefs])

  return { prefs, setPrefs }
}
